import { getDOMElements } from 'src/utils/DOM';

export const muteConsoleError = (): void => {
  jest.spyOn(console, 'error');
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-console
  console.error.mockImplementation(() => null);
};

export const unMuteConsoleError = (): void => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-console
  console.error.mockRestore();
};

/** a function that creates test ids for inputs */

type TestIdAddInnerType = (add?: string | number | boolean | null) => string;

type TestIdType = (
  type:
    | 'input_text'
    | 'input_textarea'
    | 'checkbox'
    | 'radiogroup'
    | 'dropdown'
    | 'input_masked'
    | 'format_number'
    | 'datepicker'
    | 'timepicker'
    | 'switch'
    | 'image_uploader'
    | 'input_phone',
  testId: string,
  name?: string
) => TestIdAddInnerType;

/** override the return type */
export type TestIdAddType = <T extends TestIdAddInnerType>(
  ...a: Parameters<T>
) => ReturnType<TestIdAddInnerType> | undefined;

export const getTestId: TestIdType =
  (type, testId, name = testId) =>
  (add) =>
    `${testId}_${name}_${type}${add ? `_${add.toString()}` : ''}`;

/** end a function that creates test ids for inputs */

/** creates a random string with a variable length */
export const makeStringXLong = (length: number): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getFieldsNameByDataNameAttribute = (value?: string): string[] | undefined => {
  const elems = getDOMElements(value ? `[data-name="${value}"]` : '[data-name]');
  return elems ? ([...elems].map((element) => element.getAttribute('data-name')).filter(Boolean) as string[]) : [];
};
